export default {
  title: {
    login: "%{school} - Giriş",
    registration: "%{school} - Kayıt",
    subjects: "%{school} - Ders Seçimi",
    subject: "%{school} - Ders",
    offer: "%{school} - Teklif",
    home: "%{school} - Ana Sayfa",
    dictionary: "%{school} - Sözlük",
    events: "%{school} - Etkinlikler",
    news: "%{school} - Haberler",
    profile: "%{school} - Profil",
    learn: "%{school} - Öğrenme",
    pay: "%{school} - Ders Ödemesi",
    checkInSystem: "E-postanızı girin",
    setPassword: "Giriş için şifre belirleyin.",
    createAccount: "Profil bilgilerinizi girin/denetleyin",
  },
  authCheckEmail: {
    title: "E-posta adresinizi girin",
    emailCaption: "E-posta adresi",
    continue: "Devam Et",
    or: "veya",
  },
  authPassword: {
    title: "Hesabınıza giriş yapın",
    inputCaption: "Parola",
    placeholder: "Parolayı girin",
    forgot: "Parolanızı mı unuttunuz?",
    submit: "Giriş Yap",
  },
  authRegistration: {
    title: "Hesap Kaydı",
    name: "Ad",
    phone: "Telefon Numarası",
    password: "Parola oluşturun",
    confirmPassword: "Oluşturduğunuz parolayı tekrar girin",
  },
  totalError: "Oops, bir sorun oluştu!",
  subjectChangeError: "Ders değiştirilemedi. Lütfen tekrar deneyin veya okulunuzla iletişime geçin.",
  email: "E-posta",
  personalLink: "Kişisel bağlantı",
  login: "Giriş",
  name: "İsim",
  firstLastName: "Soyadı ve adı",
  phone: "Telefon",
  formatPhone: "Telefon numarası formatı 998...",
  aboutMe: "Hakkımda",
  fullAge: "Yaşınız (tam yıl)",
  errorAge: "geçersiz yaş",
  notNumber: "değer sayı olmalı",
  registration: "Kayıt",
  password: "Parola",
  currentPassword: "Mevcut parola",
  newPassword: "Yeni parola",
  confirmPassword: "Parolayı onayla",
  confirmNewPassword: "Yeni parolayı onayla",
  forgotPassword: "Parolanızı mı unuttunuz?",
  passwordsMatch: "Parolalar uyuşmuyor",
  resetPassword: "Parola sıfırlandı, e-postanızı kontrol edin.",
  resetConfirm: "Parolayı sıfırlamak istediğinizden emin misiniz?",
  enter: "Giriş Yap",
  studentEnter: "Öğrenci Girişi",
  check: "İleri",
  signInWithGoogle: "Google ile giriş yap",
  emailIsNotRegistered: "Bu e-posta adresi kayıtlı değil",
  logout: "Çıkış",
  online: "çevrimiçi",
  offline: "çevrimdışı",
  cancel: "İptal",
  yes: "Evet",
  no: "Hayır",
  course: "Kurs",
  dictionary: "Sözlük",
  events: "Etkinlikler",
  news: "Haberler",
  words: "Kelimeler",
  wordsAreHere: "Bu kelimeler burada:",
  allWords: "Tüm kelimeler",
  phrases: "İfadeler",
  videos: "Videolar",
  exercises: "Alıştırmalar",
  theory: "Teori",
  theoryAlt: "Özet",
  theoryAdditionalFile: "Ek dosyayı indir (%{filename})",
  topic: "Konu",
  lesson: "Ders",
  lessons: "Dersler",
  profile: "Profil",
  orders: "Satın Alımlar",
  payment: "Ödemeler",
  leaderboard: "Liderlik Tablosu",
  leaderboardPerDay: "Bugünün liderleri",
  time: "Zaman",
  points: "Puanlar",
  myPoints: "Tüm dönem için aldığım puanlar",
  coins: "Madeni paralar",
  courses: "Kurslarım",
  loading: "Yükleniyor...",
  noTheory: "Bu ders için teori yok.",
  startTraining: "Eğitime başla",
  chat: {
    // === chat list / dialog additions ===
    startDialogTitle: "Sohbeti başlat",
    startDialogTooltip: "Yeni bir sohbet başlat",
    messages: "Mesajlar",
    unreadOnly: "Sadece okunmamışlar",
    delete: "Sil",
    send: "Gönder",
    sendHelper: "Mesajı göndermek için Ctrl+Enter",
    close: "Kapat",
    profile: "Profil",
    lastActivity: "Son aktivite",
    status: "Durum",
    jobTitle: "Pozisyon adı",
    tabLabel: "Sohbet",
    lastOnline: {
      time: "Son çevrimiçi: %{date}",
      weekday: "Son çevrimiçi: %{date}",
      dayMonth: "Son çevrimiçi: %{date}",
      monthYear: "Son çevrimiçi: %{date}",
    },
    read: "Okundu",
    errors: {
      wrongFormatting: "Mesaj yanlış biçimlendirilmiş",
    },
  },
  branches: "Konular",
  easy: "Kolay",
  expert: "Uzman",
  wordToLearn: "Sonra öğren",
  iKnowWord: "Biliyorum",
  videoVocabulary: "Video kelime bilgisi",
  markVideoWatched: "İzlendi olarak işaretle",
  videoWatched: "İzlendi",
  passed: "tamamlandı",
  unsupportedExercise: "Bu alıştırma türü desteklenmiyor (%{type})",
  changeCourse: "Dersi değiştir",
  currentCourse: "Mevcut ders",
  allSubjects: "Tüm dersler",
  all: "Tüm",
  subject: "Ders",
  group: "Grup",
  start: "Başla",
  chooseSubject: "Öğreneceğiniz dersi seçin",
  hourValue: "%{value} sa",
  completed: "Tamamlandı",
  notCompleted: "Tamamlanmadı",
  paidBranch: "Ücretli bölüm. Erişim için ödeme yapın.",
  buyBranch: "%{price} %{currency} karşılığında bölümü satın al",
  paidSubject: "Ücretli ders. Erişim için ödeme yapın.",
  buySubject2: "%{price} %{currency} karşılığında dersi satın al",
  decksItemNotOpen: "Bu dersi açmak için önceki dersi tamamlayın",
  decksItemNotPurchasedBranch: "Bu dersin bölümü henüz satın alınmadı",
  decksItemNotOpenLevel: "Bu dersi açmak için önceki seviyeyip geçin",
  decksItemNotOpenBranch: "Bu dersi açmak için önceki bölümü geçin",
  deckAccessDenied: "Bu ders henüz erişilebilir değil",
  openOnDate: "%{date} tarihinde açılacak",
  levelAccessIsDenied: "Bu seviye materyalleri erişilemez",
  youAreDeactivated: "Hesabınız devre dışı bırakıldı, okulunuzla iletişime geçin",
  youAreDeactivatedShort: "Hesabınız devre dışı",
  youAreHaveNotPaidOffers: "Ödenmemiş teklifleriniz var",
  yourCertificates: "Sertifikalarınız",
  emptyDeck: "Ders boş",
  nextDeck: "Sonraki ders",
  next: "İleri",
  proceed: "Devam et",
  skip: "Atla",
  more: "Daha fazla",
  exit: "Çıkış",
  details: "Detaylar",
  go: "Git",
  profileEdit: "Profili düzenle",
  userInfo: "Kullanıcı bilgisi",
  of: " / ",
  back: "Geri",
  levelPackExist: "Bu seviye paketi zaten mevcut",
  awaitingPayment: "Ödeme bekleniyor",
  bought: "Satın alındı",
  boughtUntilDate: "%{endDate} tarihine kadar satın alındı",
  availableUntilDate: "%{endDate} tarihine kadar erişim var",
  showMore: "daha fazla göster",
  hide: "gizle",
  communication: "Okulla iletişim",
  askQuestion: "Soru sor",
  noDescription: "Açıklama yok",
  description: "Açıklama:",
  onePerMonth: "Aylık abonelik",
  semiannually: "Altı aylık abonelik",
  onceAYear: "Yıllık abonelik",
  stopSubscribe: "Aboneliği durdur",
  enable: "Aboneliği başlat",
  expired: "Süresi doldu",
  buySubject: "Dersi satın al",
  buyOffer: "Satın al",
  subscribeOffer: "Abone ol",
  firstPayment: "İlk ödeme",
  accessDaysWarning: "%{smart_count} gün kaldı |||| %{smart_count} gün kaldı",
  accessDemoDaysWarning: "Demo: %{smart_count} gün kaldı |||| Demo: %{smart_count} gün kaldı",
  accessDemoButton: "Demo erişimi",
  closeButton: "Kapat",
  existOffer: "Ödenmemiş teklif mevcut",
  loginInProcess: "Giriş yapılıyor...",
  done: "Tamamlandı:",
  Levels: {
    empty: "Bu kursta henüz kullanılabilir seviye yok.",
    name: "Seviye:",
  },
  Decks: {
    scormPass: "Dersi geç say",
    proceed: "Devam et",
    stayHere: "Burada kalmak",
  },
  Exercises: {
    tabTitle: "Alıştırmalar",
    skip: "Sonraki",
    check: "Kontrol et",
    examCheck: "Gönder",
    typeAnswer: "Cevabı girin",
    next: "İleri",
    rightAnswerWas: "Doğru cevap:",
    showRightAnswer: "Doğru cevabı göster",
    rightAnswer: "Doğru cevap:",
    congratulation: "Tebrikler!",
    congratText: "Bu dersteki tüm alıştırmaları tamamladınız!",
    wrongAnswer: "Cevabınız yanlış",
    answerSaved: "Cevap kaydedildi",
    commentToAnswer: "Seçilen cevaba yorum:",
    appendix: {
      pdf: {
        tooltipButton: "Ek materyaller",
      },
    },
    type13: {
      title: "Eksikleri açılır listeden doğru kelimeyi seçerek doldurun",
    },
    type12: {
      title: "Ek bilgileri inceleyin",
    },
    type11: {
      title: {
        select: "Doğru cevabı seçin",
        keyboard: "Doğru cevabı yazın",
      },
    },
    type9: {
      title: {
        select: "Eksikleri doğru kelimeyi seçerek doldurun",
        keyboard: "Eksikleri doldurun",
      },
    },
    type8: {
      title: "Eşleştirmeleri bulun",
    },
    type7: {
      title: {
        text: "Cevabınızı yazın",
        audio: "Sesli cevap kaydedin",
      },
      recordingIsNotSupported: "Tarayıcınız ses kaydını desteklemiyor.",
      audioRecordingError: "Ses kaydı hatası: ",
      inputLabel: "Cevabınız",
      addPhotoVideo: "Fotoğraf/video ekle (en fazla %{maxCount})",
      addPhoto: "Fotoğraf ekle (en fazla %{maxCount})",
      cameraInitialization: "Başlatılıyor...",
      change: "Değiştir",
      codeToApprove: "Kod",
      homework: {
        teacherData: {
          audio: "Öğretmen ses yorumu",
          audioComment: "Öğretmen sesli yorumu",
        },
      },
      addFiles: "Dosya ekle",
      limitsHelperText: "Metin en az %{count} karakter olmalı",
      photoRequired: "Cevabınıza en az bir fotoğraf veya dosya ekleyin",
      photoViewerHint: "Görüntüyü fare tekerleğiyle yakınlaştırabilirsiniz",
    },
    type6: {
      title: "Bir öğe çizin",
      checkButtonText: "Anladım!",
    },
    type3: {
      title: "Öğeleri doğru sıraya sürükleyin",
      hint: "Alt kısımdaki öğeleri buraya sürükleyin",
    },
    type5: {
      title: "Öğeleri seçin",
      hint: "Ekranın altından gerekli öğeleri seçin (seçmek için dokunun)",
    },
    type2: {
      title: "Eksik kelimeyi seçin",
    },
  },
  Events: {
    headNotice: "Etkinlik zamanı zaman diliminize göre gösterilir",
    title: "Bu haftanın etkinlikleri",
    startTime: "Başlangıç zamanı",
    finishTime: "Bitiş zamanı",
    group: "Grup",
    persons: "%{smart_count} öğrenci |||| %{smart_count} öğrenci",
    leader: "Eğitmen",
    tag: "Kategori",
    joinedCheckbox: "Kayıtlı",
    joined: "Seçilenler:",
    interested: "Kayıt",
    registered: "Kayıtlı",
    enter: "Giriş",
    limitPopupInfo: "Etkinlik kayıt limitine ulaştınız",
    eventHasStarted: "Etkinlik başladı!",
    registrationNotice: "Başarıyla kayıt oldunuz! Giriş butonu %{date_and_time} tarihinde aktif olacak. Bu tarihten sonra kaydı iptal edemezsiniz",
    registrationNoticeNoUrl: "Başarıyla kayıt oldunuz! %{date_and_time} tarihinden sonra kaydı iptal edemezsiniz",
    cancelRegistration: "Kaydı iptal etmek istediğinize emin misiniz?",
    calendarLink: "Google Takvime ekle",
    status_planned: "Planlandı",
    status_started: "Başladı",
    status_completed_successfully: "Tamamlandı",
    status_last_minute_cancellation: "Son dakikada iptal edildi",
    status_late_cancellation: "Geç iptal",
    status_canceled: "İptal edildi",
    status_moved: "Ertelendi",
  },
  statistic: {
    title: "İstatistik",
    points: "Puanlar",
    phrases: "İfadeler",
    missions: "Görevler",
    words: "Kelimeler",
    time: "Zaman",
  },
  status: {
    wait_review: "Kontrol bekleniyor",
    on_review: "Kontrol ediliyor",
    approved: "Onaylandı",
    not_approved: "Reddedildi",
    not_approved_allow_update: "Reddedildi (düzeltilmesine izin var)",
    ai_reviewed: "Yapay Zeka ile kontrol edildi",
  },
  homeworks: {
    tabName: "Görevler",
    todo: "Yapılacak",
    done: "Tamamlananlar",
    topic: "Konu",
    lesson: "Ders",
    onlyInMobileApp: "Sadece mobil uygulamada mevcut",
    todoHomework: "KONTROL GÖREVİ",
    postToDoButton: "Gönder",
    types: {
      homework_todo: "ToDo",
      exercise: "Alıştırma",
    },
    waitAIReview: "Bekleyin, AI yanıtı kontrol ediyor",
    dontWait: "beklememek",
    checkingHomework: "Ödevimi kontrol ediyorum",
  },
  exam: {
    popupTitle: "Sınavlı Ders",
    popupDescr1: "Bu bir sınavlı derstir. Önce tüm ek materyalleri inceleyin, ardından alıştırmalara geçin.",
    popupDescr2: `“Alıştırmalar” sekmesine geçtiğiniz anda sınav süresi başlar.`,
    popupDescr3: '"Teori" ve "Video" sekmeleri sınav süresini başlatmaz.',
    cancelButton: "Başka zaman",
    positiveButton: "Anladım (%{smart_count} deneme)  |||| Anladım (%{smart_count} deneme)",
    questions: "%{smart_count} soru |||| %{smart_count} soru",
    oneAttempt: "Her soru için bir deneme",
    timeLimit: "Zaman sınırı: %{limit} dakika",
    noPause: "Sınav duraklatılamaz",
    progress: "%{current} soru / %{total}",
    closeButton: "Kapat",
    viewButton: "Sonuçları görüntüle",
    retakeButton: "Tekrar dene (%{smart_count} deneme)  |||| Tekrar dene (%{smart_count} deneme)",
    finishedPopupTitle: "Sınav Sonuçları",
    examPassed: "Sınav geçildi",
    examNotPassed: "Sınav geçilemedi",
    waitHomeworks: "%{smart_count} soru kontrol ediliyor |||| %{smart_count} soru kontrol ediliyor",
    result: "Sonucunuz:",
  },
  subjects: {
    unavailable: "Bu anda ders mevcut değil",
  },
  orderStatus: {
    approved: "Başarılı",
    canceled: "İptal edildi",
    pending: "Beklemede",
  },
  notificationsTypes: {
    event: "Etkinlik",
    invoice: "fatura",
    news: "Haber",
    homework: "Ödev",
    homework_todo: "ToDo Görevi",
    type: {
      exercise: "Alıştırma",
      homework_todo: "ToDo Görevi",
    },
  },
  notificationsAlert: {
    subscribe: "Bildirimleri aç",
    unsubscribe: "Bildirimleri kapat",
    instructions: "Adres çubuğunun solundaki kilit 🔒 simgesine tıklayın ve bildirim izinlerini aşağıdaki görseldeki gibi değiştirin veya tarayıcı ayarlarından genel bildirim izinlerini güncelleyin.",
    permissionDefault: {
      title: "Bildirimlere abone olun 🔔",
      body: "Ödev durumu değişiklikleri, etkinlik başlangıcı, haberler, yeni yapılacak görevler hakkında bildirimler. Reklam yok, yalnızca öğreniminizle ilgili bildirimler!",
    },
    permissionDenied: {
      title: "Şu anda bildirimler kapalı ❌",
      body: "Önceden bildirimleri reddettiniz. Bildirimler olmadan ödev durumu değişiklikleri ve etkinlik başlangıcı hakkında zamanında bilgi alamazsınız. Bildirimleri açmak için aşağıdaki talimatları izleyin:",
    },
    permissionGranted: {
      title: "Şu anda bildirimler açık ✔",
      body: "Bildirimleri kapatmak istediğinizden emin misiniz? Bildirimler olmadan ödev durumu değişiklikleri ve etkinlik başlangıcı hakkında zamanında bilgi alamazsınız. Bildirimleri kapatmak için aşağıdaki talimatları izleyin:",
    },
  },
  feedbackDialog: {
    sendFeedback: "Geri bildirim gönder",
    placeholder: "Deneyimlerinizi anlatın",
    defaultInstruction: "Değerlendirmek için kaydırıcıyı kullanın",
    eventInstruction: "Etkinliği nasıl buldunuz değerlendirin",
    submitError: "Lütfen bir değerlendirme seçin",
    submitSuccess: "Teşekkürler! Geri bildiriminiz başarıyla gönderildi",
    wasNotPresent: "Etkinliğe katılmadım",
    dateOfEvent: "Etkinlik tarihi:",
  },
  congratulation: {
    mission: "Tebrikler, %{name} görevi tamamlandı!",
    missionTask: {
      title: "🎉 Tebrikler! %{name} görevi tamamlandı.",
      content: "Görevin bitmesine <b>%{need} görev</b> kaldı — böyle devam et!",
    },
  },
  accountNotFound: "Bu e-posta adresi herhangi bir eğitim ortamıyla ilişkili değil. Okul yöneticinizle iletişime geçin",
  demoAccess: "SkillzRun’ı işletmeniz/okulunuz için denemek ister misiniz? Platformu test etmek için kaydolun",
  structure: "Yapı",
  version: {
    message: "Uygulamanın yeni sürümü mevcut. Güncellemek için sayfayı yenileyin",
    button: "Yenile",
  },
  missions: {
    title: "Görevler",
    startButton: "Görevi başlat",
    missionStarted: "Görev başlatıldı %{started}",
    started: "Görev başladı!",
    tasks: {
      title: "Görev detayları",
    },
  },
  productCatalog: {
    title: "Ürün kataloğu",
    coinBalance: "Bakiyeniz:",
    notEnoughCoins: "Yeterli para yok",
    order: "Sipariş vermek",
    orderConfirmation: "Sipariş onayı",
    price: "Fiyat:",
    remaining: "Kalan:",
    instructionForForm: "Siparişinizin işlenmesini hızlandırmak için lütfen aşağıdaki bilgileri doldurun.",
    address: "Adres",
    thankText: "Teşekkürler! Siparişiniz işleme alınmıştır.",
    pleaseWait: "Bekleyin, yönetici sizinle iletişime geçecektir.",
    pleaseWaitPersona: "SMS'i bekleyin. Takip numaranız size gönderilecektir.",
    thankTextOffer: "Teşekkürler! Satın alma işlemi tamamlandı.",
    contentAvailableText: "İçerik zaten kullanılabilir — hemen şimdi kullanabilirsiniz.",
    deliveryAddress: "Teslimat adresini girin",
    helperText: "Tam adresi veya şehri ve Nova Poshta/Ukrposhta şubesinin numarasını belirtin.",
    deliveryOptions: "*Teslimat seçenekleri, sipariş alındıktan sonra yönetici ile netleştirilecektir.",
    validationPhoneFormat: "Telefon numarası 10 haneli olmalı ve 0 ile başlamalıdır.",
    recipientNameLabel: "Ad soyad",
    recipientNameRequired: "Lütfen alıcının adını girin.",
    npCityRequired: "Lütfen teslimat şehrini seçin.",
    npWarehouseRequired: "Lütfen Nova Poshta şubesini seçin.",
    npCityLabel: "Nova Poshta şehri",
    npCityPlaceholder: "Şehir adını yazmaya başlayın",
    npCitySearching: "Şehirler aranıyor...",
    npCitySelectHint: "Listeden bir şehir seçin",
    npCityTypeHint: "Şehir adını yazmaya başlayın (en az 3 karakter)",
    npBranchTypeDepartments: "Şubeler",
    npBranchTypePostomats: "Paket dolapları",
    npWarehouseLabel: "Nova Poshta şubesi",
    npWarehousePlaceholder: "Bir şube seçin",
    npWarehouseLoading: "Şubeler yükleniyor...",
    npWarehouseSelectHint: "Listeden bir şube seçin",
    npWarehouseEmpty: "Bu şehir için şube bulunamadı",
    npWarehouseCityFirst: "Önce bir şehir seçin",
    inProcessing: "İşlemede",
    purchased: "Satın alındı",
    oneTimeAlreadyPurchased: "Bu ürün zaten satın alındı",
  },
  companyReviewTitle: "Okulumuzu bir arkadaşınıza veya tanıdığınıza tavsiye etme olasılığınız nedir?",
  companyReviewText: '1\'den 10\'a kadar bir ölçekte değerlendirin, burada 1 "kesinlikle olası değil" ve 10 "çok olası" anlamına gelir',
  subjectReviewTitle: "Bu kursu platformda almak sizin için ne kadar ilginçti?",
  subjectReviewText: '1\'den 10\'a kadar bir ölçekte değerlendirin, burada 1 "hiç ilginç değil" ve 10 "çok ilginç" anlamına gelir',
  lessonsCount_one: "%{smart_count} ders",
  lessonsCount_few: "%{smart_count} dersler",
  lessonsCount_many: "%{smart_count} dersler",
  policySettings: {
    termsAndConditions: "Şartlar ve Koşullar",
    refund: "Gizlilik Politikası",
  },
  promoCode: "Promosyon Kodu",
  promoInvalid: "Promosyon kodu geçersiz",
};
